import { call, getContext, takeEvery } from "redux-saga/effects"
import { createActions } from "reduxsauce"
import { getCompositeSecurityUrl } from "helpers/compositeSecurities"

export const { Types, Creators } = createActions({
  openCompositeSecurity: ["account", "security", "newWindow", "modelId"],
}, {
  prefix: "ompnt/modules/composite-security/",
})

function* handleOpenCompositeSecurity({ account, security, newWindow, modelId }) {
  const { navigate } = yield getContext("router")
  const url = getCompositeSecurityUrl(account, security, modelId)
  if (!url) {
    yield call(navigate, `/${account}/404`)
  } else if (newWindow) {
    yield call(window.open, url, "_blank")
  } else {
    yield call(navigate, url)
  }
}

export function* saga() {
  yield takeEvery(Types.OPEN_COMPOSITE_SECURITY, handleOpenCompositeSecurity)
}
